import { DocumentSnapshot } from "api/firebase";

export const unpackDocs = <T>(doc: DocumentSnapshot<T>) =>
  ({
    ...doc.data(),
    id: doc.id,
  } as T);
